import { BrowserRouter, Routes, Route, Navigate, useNavigate, useLocation, Link } from "react-router-dom";
import { AuthProvider } from "@/client/lib/auth-context";
import { Toaster } from "@/client/components/base/toast";
import AppLayout from "@/client/components/layout/AppLayout";
import ExpiryReturnDistributionPage from "@/client/pages/ExpiryReturnDistributionPage";
import RegisterPage from "@/client/pages/RegisterPage";
import LoginPage from "@/client/pages/LoginPage";
import MePage from "@/client/pages/MePage";
import TrackersPage from "@/client/pages/TrackersPage";
import ScannersPage from "@/client/pages/ScannersPage";
import StrategiesPage from "@/client/pages/StrategiesPage";
import PositionsPage from "@/client/pages/PositionsPage";
import AnalysisPage from "@/client/pages/AnalysisPage";
import ReturnsAnalysisPage from "@/client/pages/ReturnsAnalysisPage";
import TradeLogAnalysisPage from "@/client/pages/TradeLogAnalysisPage";

const App = () => (
    <BrowserRouter>
        <AuthProvider>
            <Toaster>
                <Routes>
                    <Route path="/register" element={<RegisterPage />} />
                    <Route path="/login" element={<LoginPage />} />

                    <Route element={<AppLayout />}>
                        <Route path="/" element={<Navigate to="/trackers" replace />} />
                        <Route path="/trackers" element={<TrackersPage />} />
                        <Route path="/scanners" element={<ScannersPage />} />
                        <Route path="/strategies" element={<StrategiesPage />} />
                        <Route path="/positions" element={<PositionsPage />} />
                        <Route path="/analysis" element={<AnalysisPage />} />
                        <Route path="/analysis/returns" element={<ReturnsAnalysisPage />} />
                        <Route path="/analysis/trade-log" element={<TradeLogAnalysisPage />} />
                        <Route
                            path="/analysis/expiry-returns/:expiryType/:underlying"
                            element={<ExpiryReturnDistributionPage />}
                        />
                        <Route path="/me" element={<MePage />} />
                    </Route>
                </Routes>
            </Toaster>
        </AuthProvider>
    </BrowserRouter>
);

export const useRouteUtils = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const isActive = (path: string) => pathname === path || pathname.startsWith(path + "/");

    return { navigate, isActive, Link };
};

export default App;
